/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppDocumentRequest { 
    platform: AppDocumentRequest.PlatformEnum;
    type: AppDocumentRequest.TypeEnum;
    content: string;
}
export namespace AppDocumentRequest {
    export type PlatformEnum = 'MOBILE' | 'WEB';
    export const PlatformEnum = {
        Mobile: 'MOBILE' as PlatformEnum,
        Web: 'WEB' as PlatformEnum
    };
    export type TypeEnum = 'PRIVACY_POLICY' | 'USER_AGREEMENT';
    export const TypeEnum = {
        PrivacyPolicy: 'PRIVACY_POLICY' as TypeEnum,
        UserAgreement: 'USER_AGREEMENT' as TypeEnum
    };
}


